import { render, staticRenderFns } from "./pages5.vue?vue&type=template&id=463f8c8e&scoped=true&"
import script from "./pages5.vue?vue&type=script&lang=js&"
export * from "./pages5.vue?vue&type=script&lang=js&"
import style0 from "./pages5.vue?vue&type=style&index=0&id=463f8c8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f8c8e",
  null
  
)

export default component.exports